import user from './services'

export const Success = "success"
export const Failed = "failed"
export const Header = { 'Content-Type': 'application/json', }

export const BaseUrl = HBB_APP_API_URL

// helpers
const getAuthHeader = () => {
    let header = Header
    if (user.getAccessToken()) {
        header = Object.assign({}, Header, {Authorization: "Bearer " + user.getAccessToken()})
    }
    // console.log(header)
    return header
}

const getHeader = () => {
    return Object.assign({}, Header)
}

export function ajax(url, method, data = null, token = true, appendBaseUrl = true) {
    return new Promise((resolve, reject) => {
        let apiUrl = url 
        let headers = null

        if (appendBaseUrl) {
            apiUrl = BaseUrl + url
            if (LOGGER_NEEDED) {
                //console.log("Url", apiUrl)
            }
        }

        if(token) {
            headers = getAuthHeader()
        } else {
            headers = getHeader() 
        }

        let body = {
            method: method,
            headers: headers,
        }

        if (data) {
            body.body = JSON.stringify(data)
        }

        fetch(apiUrl, body)
            .then(res => {
                switch (res.status) {
                    case 500:
                        console.error('Some server error')
                        reject(res)
                        break
                    case 401:
                        console.error('Unauthorized')
                        reject(res)
                        break
                    case 400:
                        console.warn('Bad Request')
                        reject(res)
                        break

                    default:
                        if (LOGGER_NEEDED) {
                            console.log("Default response in Api response")
                        }
                        break
                }

                resolve(res.json())

                // let stateData = JSON.parse(localStorage.getItem(Constants.HBB_STORE_NAME))
                // let response = res.clone()
                // response.json().then(data => {
                    // if (stateData && stateData.user && stateData.user.build_number && data && data.app_build_no) {
                    //     if (stateData.user.build_number === data.app_build_no) {
                    //         resolve(res.json())
                    //     } else {
                    //         resolve(res.json())
                    //         store.dispatch(buildNumberUpdate(data.app_build_no))
                    //         window.location.reload()
                    //     }
                    // } else {
                    //     resolve(res.json())
                    //     if (!window.location.href.includes("registration")) {
                    //         store.dispatch(buildNumberUpdate(data.app_build_no))
                    //         window.location.reload()
                    //     }
                    // }
                // })
            })
            .catch(err => {
                console.log(err)
                // console.log(apiUrl)
                // store.dispatch(expiryTokenlogout(false))
                // console.log()
                // if (err.constructor === {}.constructor)
                // if (typeof err === 'object')
                //     reject(err.json())
                // else
                reject(err)
                console.error("Respone error")
            })
    })
}




// WEBPACK FOOTER //
// ./src/services/helper.js